import React from "react";
import { Link } from "react-router-dom";
import { StyledAnchor } from "./_styled";

export default function dhInternalLinkProcessor() {
  const processDHInternalLink = (node) => {
    return (
      <StyledAnchor
        linkComponent={Link}
        href={node.attribs["data-reference-id"]}
      >
        {node.attribs["data-value"]}
      </StyledAnchor>
    );
  };

  return { processDHInternalLink };
}
